import { Button, FormControl, Layout, LayoutContainer, Page, useAppConfig } from "@fdoh/health-ui-react";
import { useMemo, useRef } from "react";
import CSS from 'csstype';
import { DataTable} from "@fdoh/health-react";
import { Link, useHistory, useLocation, useParams } from "react-router-dom";
import { useData } from "../../../hooks";
import {UserTrainingInput, UserTrainingInputColumns} from "./UserTraining.types"
import { DateFormat, Row } from "@fdoh/health-react";
import html2canvas from "html2canvas";
import {jsPDF} from 'jspdf';
import useClient from "../../../hooks/useInspectionClient";
import { userInfo } from "os";
import useProfile from "../../../hooks/useProfile";
import { UserSecurityInput } from "../../../components/DBProtectedRoute.types";
import { useMsal } from "@azure/msal-react";
// import DataTable from "react-data-table-component";




const UserTrainingViewPage = () => {
    const { search } = useLocation();
    const history = useHistory();
    const client = useClient();
    const config = useAppConfig();

    const application = config.applications.filter(x => x.name === "privateProviderInspectionApi")[0];   
    const userStatus = useProfile(application) as UserSecurityInput;

    const goToSearchPage = () => {
        history.push("/")
    }
    const user =  useProfile(application) as UserSecurityInput;
    const { accounts } = useMsal();    
      const userEmail = accounts[0] && accounts[0].username;
    const path = "UserTraining/GetUserTrainingVideosByUserID/" + userEmail;
    const userTrainingData = useData<UserTrainingInput[]>(path);
    
    
    return userTrainingData ?  (
        <Page.Container>
      <Page.Header preTitle="Private Provider Inspection" title="OSTDS Training Material" />
      <Page.Body>
        <Layout.Container>
          <div className="row row-dec row-cards">
            <div className="col-lg-12">
              <DataTable
                name="PPIPortalTrainingVideos"
                columns={UserTrainingInputColumns}
                data={userTrainingData}
                title="PPI Portal Training Videos"
                globalFilter
                striped
                vcenter
              />
            </div>            
          </div>
        </Layout.Container>        
      </Page.Body>
    </Page.Container>
  ) : <Page.Container>
      <Page.Header preTitle="Private Provider Inspection" title="Welcome" />
      <Page.Body>
          <Layout.Container>
              <div className="row row-dec row-cards">
                  <div className="col-lg-12">
                  </div>
              </div>
          </Layout.Container>
      </Page.Body>
  </Page.Container>;
    }
    
export default UserTrainingViewPage;